var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYolohblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.593,
    height: 33.581,
    viewBox: "0 0 133.593 33.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6005",
    "data-name": "Rectangle 6005",
    width: 133.593,
    height: 33.581,
    fill: "#09143a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_128565",
    "data-name": "Group 128565",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91125",
    "data-name": "Path 91125",
    d: "M284.232,1.206a1.206,1.206,0,0,0-1.52-1.164c-2.3.621-5.8,1.587-7.589,2.083-1.705.471-2,.919-2,2.458,0,.158,0,19.683,0,20.152h0c0,4.244,0,7.639,0,7.639a1.206,1.206,0,0,0,1.52,1.164c2.3-.621,5.8-1.587,7.589-2.083,1.705-.471,2-.919,2-2.458,0-.158,0-27.791,0-27.791",
    transform: "translate(-211.892 0)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91126",
    "data-name": "Path 91126",
    d: "M160.835,25.931c0-14.642-14.1-14.136-14.1-14.136s-14.114-.516-14.114,14.136,14.114,14.177,14.114,14.177,14.1.464,14.1-14.177m-14.123,7.117c-2.145,0-2.247-3.714-2.247-4.965V23.819c0-1.251.1-4.965,2.265-4.965s2.265,3.714,2.265,4.965v4.264c0,1.251-.137,4.965-2.282,4.965",
    transform: "translate(-102.89 -9.148)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91127",
    "data-name": "Path 91127",
    d: "M365.5,25.931c0-14.642-14.1-14.136-14.1-14.136s-14.114-.516-14.114,14.136S351.4,40.108,351.4,40.108s14.1.464,14.1-14.177m-14.123,7.117c-2.145,0-2.247-3.714-2.247-4.965V23.819c0-1.251.1-4.965,2.265-4.965s2.264,3.714,2.264,4.965v4.264c0,1.251-.137,4.965-2.282,4.965",
    transform: "translate(-261.672 -9.148)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91128",
    "data-name": "Path 91128",
    d: "M8.119,35.812a8.579,8.579,0,0,0,7.2-3.5,11.63,11.63,0,0,0,1.476-3.16c.1-.311.2-.518.478-.518.36,0,.362.326.33.607a10.259,10.259,0,0,1-.587,2.37,18.717,18.717,0,0,0-1.642,7.022v3.849a1.206,1.206,0,0,0,1.52,1.164c2.3-.621,5.8-1.587,7.589-2.083,1.705-.471,2-.919,2-2.458s-.016-19.249-.016-24.865a1.2,1.2,0,0,0-1.2-1.2H16.578a1.2,1.2,0,0,0-1.2,1.206c0,2.312,0,8.508,0,10.172,0,3.318-1.382,4.66-2.564,4.66s-1.679-.938-1.679-2.107V14.239a1.2,1.2,0,0,0-1.2-1.2h-8.7a1.2,1.2,0,0,0-1.205,1.2C.017,16.364,0,20.978,0,27.351c0,6.935,4.875,8.462,8.119,8.462",
    transform: "translate(0 -10.113)",
    fill: "#09143a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91129",
    "data-name": "Path 91129",
    d: "M496.115,7.926a8.579,8.579,0,0,0-7.2,3.5,11.631,11.631,0,0,0-1.477,3.16c-.1.311-.2.518-.477.518-.36,0-.362-.326-.33-.607a10.245,10.245,0,0,1,.587-2.37,18.718,18.718,0,0,0,1.642-7.022V1.257A1.206,1.206,0,0,0,487.335.093c-2.3.621-5.8,1.587-7.589,2.083-1.705.471-2,.919-2,2.458s.016,19.249.016,24.865a1.2,1.2,0,0,0,1.2,1.2h8.689a1.2,1.2,0,0,0,1.2-1.206c0-2.312,0-8.508,0-10.172,0-3.318,1.382-4.66,2.564-4.66s1.679.938,1.679,2.107V29.5a1.2,1.2,0,0,0,1.2,1.2h8.7a1.2,1.2,0,0,0,1.205-1.2c.007-2.128.024-6.742.024-13.115,0-6.935-4.875-8.462-8.119-8.462",
    transform: "translate(-370.641 -0.039)",
    fill: "#09143a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolohblue);
export default __webpack_public_path__ + "static/media/yolohblue.b665c16b5b8cb9b864e9dd348c44bd75.svg";
export { ForwardRef as ReactComponent };